export default __webpack_public_path__ + "static/media/SURF.4e1e16dc.svg";